export default __webpack_public_path__ + "static/media/server-down.ecc109ff.png";